import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-finance-recharge-config",
  "use": "icon-finance-recharge-config-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-finance-recharge-config\">\r\n  <defs><style type=\"text/css\"></style></defs>\r\n  <path d=\"M512 64C264.8 64 64 264.8 64 512s200.8 448 448 448 448-200.8 448-448S759.2 64 512 64z m0 832c-211.2 0-384-172.8-384-384s172.8-384 384-384 384 172.8 384 384-172.8 384-384 384z\" p-id=\"2118\" />\r\n  <path d=\"M320 384h384v64H320zM320 480h384v64H320zM320 576h384v64H320z\" p-id=\"2119\" />\r\n  <path d=\"M320 320h64v64h-64zM416 320h64v64h-64zM512 320h64v64h-64zM608 320h64v64h-64z\" p-id=\"2120\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/finance-recharge-config.svg
// module id = 9S1o
// module chunks = 46